import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import { AllAPIResponses, CarbonError } from './../../../index';
type Payload = {
  aliasNodeId: number;
  endTime: string;
};
/* 
  Updates end time for all channels 
*/
const put = async (payload: Payload): Promise<AllAPIResponses<{}>> => {
  const resp = await req.put(
    '/api/aliaschannels/bulk',
    JSON.stringify(payload)
  );

  try {
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: {},
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};
export default put;
